import moment from "moment";
import { isValidPhoneNumber } from "libphonenumber-js";

export const validateRequired = value => {
  if (typeof value === "number") return true;
  if (!value) return false;
  if (typeof value == "string") return value.trim().length > 0;
  return true;
};

export const validateEmail = email => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validateDate = date => {
  return moment(date, "YYYY-MM-DD", true).isValid();
};

export const validateDateTime = date => {
  return moment(date, "YYYY-MM-DD HH:mm:ss", true).isValid();
};

export const validatePhoneNumber = phone => {
  return isValidPhoneNumber(phone);
};

export const validateSSN = ssn => {
  const justNumbers = ssn.replace(/[^0-9]+/g, "");
  return justNumbers.length == 9;
};

export const validateZipcode = zipcode => {
  return zipcode.match(/^\d{5}(?:-\d{4})?$/);
};

export const validateNumberGreaterEqualThan = (value, min) => {
  return value >= min;
};

export const validateNumberLessEqualThan = (value, max) => {
  return value <= max;
};

export const validateLengthGreaterEqualThan = (value, min) => {
  return value.toString().trim().length >= min;
};

export const validateLengthLessEqualThan = (value, max) => {
  return value.toString().trim().length <= max;
};

export const validateIsNumber = number => {
  const validAreaCode = number.match(/^[0-9]*$/);
  return validAreaCode;
};
